var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2001 14.7H14.4001",
    stroke: "#433063",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.19995 14.7H10.14",
    stroke: "#433063",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.19995 19.5H12",
    stroke: "#433063",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.19995 9.9C1.19995 3.9 3.59995 1.5 9.59995 1.5H13.2",
    stroke: "#433063",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8 11.1V17.1C22.8 23.1 20.4 25.5 14.4 25.5H9.59995C3.59995 25.5 1.19995 23.1 1.19995 17.1V14.676",
    stroke: "#433063",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0001 11.1C14.4001 11.1 13.2001 9.9 13.2001 6.3V1.5L22.8001 11.1",
    stroke: "#433063",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentText);
export default __webpack_public_path__ + "static/media/document-text.ada8bcc2959410c9635205df73b47cc8.svg";
export { ForwardRef as ReactComponent };